import React from 'react';
import { Loader2, Camera, Copy, Link as LinkIcon } from 'lucide-react';

/**
 * "Capture" tab body of the Demo Toolkit — screenshot, JSON snapshot,
 * shareable demo link. Pure UI — handlers come from the parent.
 */
export default function DemoCaptureTab({ busy, capturePng, copyJson, copyMagicLink }) {
  return (
    <>
      <button
        onClick={capturePng}
        disabled={busy === 'screenshot'}
        className="flex items-center gap-2.5 rounded-lg px-3 py-2 text-xs font-medium text-slate-700 transition-colors hover:bg-violet-50 hover:text-violet-700 disabled:opacity-60"
        data-testid="toolkit-capture-png-btn"
      >
        {busy === 'screenshot' ? (
          <Loader2 className="h-4 w-4 animate-spin text-violet-500" />
        ) : (
          <Camera className="h-4 w-4 text-violet-500" />
        )}
        <span>Capture page (PNG)</span>
      </button>
      <button
        onClick={copyJson}
        disabled={busy === 'json'}
        className="flex items-center gap-2.5 rounded-lg px-3 py-2 text-xs font-medium text-slate-700 transition-colors hover:bg-sky-50 hover:text-sky-700 disabled:opacity-60"
        data-testid="toolkit-copy-json-btn"
      >
        {busy === 'json' ? (
          <Loader2 className="h-4 w-4 animate-spin text-sky-500" />
        ) : (
          <Copy className="h-4 w-4 text-sky-500" />
        )}
        <span>Copy JSON snapshot</span>
      </button>
      <button
        onClick={copyMagicLink}
        disabled={busy === 'magic'}
        className="flex items-center gap-2.5 rounded-lg px-3 py-2 text-xs font-medium text-slate-700 transition-colors hover:bg-amber-50 hover:text-amber-700 disabled:opacity-60"
        data-testid="toolkit-copy-demo-link-btn"
        title="Generate a single-use auto-login URL for prospects (valid 24h)"
      >
        {busy === 'magic' ? (
          <Loader2 className="h-4 w-4 animate-spin text-amber-500" />
        ) : (
          <LinkIcon className="h-4 w-4 text-amber-500" />
        )}
        <span>Copy shareable demo link</span>
      </button>
    </>
  );
}
